import { enCA, frCA } from 'date-fns/locale';

export const Locales = {
  en: enCA,
  fr: frCA,
};
